import React, { useEffect, useState } from 'react'
import '../../App.css'

const CanvasDragAndDrop = ({
    canvasList,
    reArrangeCanvasHandler,
    setActiveCanvasId
}) => {
    const [items, setItems] = useState([])
    const [canvasNames, setCanvasNames] = useState([])

    useEffect(() => {
        if (Object.keys(canvasList).length > 0) {
            const tmpItems = []
            for (const item in canvasList) {
                const existingList = items.filter(
                    (canvas) => canvas.oldSerialId === canvasList[item]?.serial
                )
                if (existingList.length === 0) {
                    tmpItems.push({
                        oldSerialId: canvasList[item]?.serial,
                        canvasId: item,
                        name: canvasList[item]?.canvasName,
                        newSerialId: null
                    })
                }
            }
            let newItems = [...items, ...tmpItems]

            newItems = newItems.filter((item) => [item.canvasId] in canvasList)
            setItems(newItems)
        } else {
            setItems([])
        }
    }, [Object.keys(canvasList).length])

    useEffect(() => {
        if (Object.keys(canvasList).length > 0) {
            const tmpItems = []
            for (const item in canvasList) {
                tmpItems.push({
                    canvasId: item,
                    name: canvasList[item]?.canvasName
                })
            }

            setCanvasNames(tmpItems)
        }
    }, [Object.keys(canvasList).length])

    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('index', index)
    }

    const handleDragOver = (e) => {
        e.preventDefault()
    }

    const handleDrop = async (e, index) => {
        setActiveCanvasId(null)
        const dragIndex = e.dataTransfer.getData('index')
        const newItems = [...items]
        const draggedItem = { ...newItems[dragIndex] }
        newItems[index] = { ...newItems[index] }
        newItems.splice(dragIndex, 1)
        newItems.splice(index, 0, draggedItem)

        const tmpItems = []
        for (let i = 0; i < newItems.length; i++) {
            tmpItems.push({ ...newItems[i], newSerialId: Date.now() + (i + 1) })
        }

        setItems(tmpItems)
    }

    const getCanvasNameById = (canvasId) => {
        const selectedCanvas = canvasNames.find(
            (item) => item.canvasId === canvasId
        )
        return selectedCanvas !== undefined ? selectedCanvas.name : ''
    }

    return (
        <div className='canvas-draggable-content'>
            {items.map((item, index) => (
                <div
                    key={index}
                    className='draggable'
                    draggable='true'
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDrop(e, index)}
                >
                    {getCanvasNameById(item.canvasId)}
                </div>
            ))}
            <div className='draggable-btn-wrapper'>
                <button
                    type='submit'
                    className='btn btn-primary draggable-btn'
                    onClick={() => reArrangeCanvasHandler(items)}
                >
                    Save
                </button>
            </div>
        </div>
    )
}

export default CanvasDragAndDrop
